__webpack_require__.p = "/djstyle/";